export * from './status.component';



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/status/index.ts